import React from "react";
import OperatorPanel from "../pages/OperatorPanel";

// The user object is expected to have user.counter_id
export default function OperatorPage({ user }) {
  // If the user object or counter_id is missing, display an error or redirect
  if (!user || !user.counter_id) {
    return (
      <div style={{ padding: '20px', textAlign: 'center', color: 'red' }}>
        <h2>Error: Counter information missing.</h2>
        <p>Please ensure your user account is assigned to a counter and log in again.</p>
        {/* You might add a logout button or redirect here */}
      </div>
    );
  }

  // If counterId is available from the user object, directly render the OperatorPanel
  // No more manual selection buttons are needed.
  return <OperatorPanel counterId={user.counter_id} />;
}